import gql from 'graphql-tag'

export const LOGIN = gql`
  mutation($email: String!, $password: String!) {
    login(email: $email, password: $password)
  }
`
export const REGISTER = gql`
  mutation register($email: String!, $password: String!) {
    register(email: $email, password: $password)
  }
`

export const CHANGE_PASSWORD = gql`
  mutation($email: String!, $oldPassword: String!, $newPassword: String!) {
    changePassword(
      email: $email
      oldPassword: $oldPassword
      newPassword: $newPassword
    )
  }
`

export const FORGOT_PASSWORD = gql`
  mutation($email: String!) {
    forgotPassword(email: $email)
  }
`

export const RESET_PASSWORD = gql`
  mutation($email: String!, $token: String!, $password: String!) {
    resetPassword(email: $email, token: $token, password: $password)
  }
`

export const END_TAKEOVER = gql`
  mutation($projectId: ID!, $customerId: ID!) {
    endTakeOver(projectId: $projectId, customerId: $customerId) {
      id
      uuid
      isHumanTakingOver
    }
  }
`

export const START_TAKEOVER = gql`
  mutation($projectId: ID!, $customerId: ID!) {
    startTakeOver(projectId: $projectId, customerId: $customerId) {
      id
      uuid
      isHumanTakingOver
    }
  }
`

export const TRACK_OPEN_TAKEOVER_CUSTOMER_CHAT = gql`
  mutation($projectId: ID!, $customerId: ID!) {
    trackOpenTakeOverCustomerChat(
      projectId: $projectId
      customerId: $customerId
    ) {
      id
      uuid
      unSeenMessageAfterTakingOver
    }
  }
`

export const ADD_MESSAGE = gql`
  mutation($projectId: ID!, $customerId: ID!, $data: DataInput) {
    addMessage(projectId: $projectId, customerId: $customerId, data: $data) {
      messageUUID
      data {
        type
        value
      }
      createdAt
      consoleDetail {
        firstname
        lastname
        id
        email
      }
    }
  }
`

export const RESEND_EMAIL_VERIFICATION = gql`
  mutation {
    resendVerifyEmail
  }
`

export const VERIFY_EMAIL = gql`
  mutation verifyEmail($token: String!) {
    verifyEmail(token: $token)
  }
`
export const EDIT_MEMBER = gql`
  mutation($projectId: ID!, $id: ID!, $role: MemberRole!) {
    editMemberRole(id: $id, projectId: $projectId, role: $role) {
      id
      email
      role
    }
  }
`

export const DELETE_MEMBER = gql`
  mutation($projectId: ID!, $id: ID!) {
    deleteMember(id: $id, projectId: $projectId) {
      id
      projectId
      email
      role
    }
  }
`

export const ADD_PRODUCT = gql`
  mutation($projectId: ID!, $product: InputProduct!, $categoryId: ID!) {
    addProduct(
      projectId: $projectId
      product: $product
      categoryId: $categoryId
    ) {
      id
      name
      brand
      categoriesV2 {
        id
        category
      }
      properties {
        id
        name
        value
      }
      images {
        src
      }
      description
      defaultPrice
      isCustomSKU
      productCode
      productSKUs {
        id
        price
        productCode
        productType {
          id
          value
          key {
            id
            key
          }
        }
        deleted
        selected
        reserved
        inventory
        image {
          src
        }
      }
    }
  }
`

export const EDIT_PRODUCT = gql`
  mutation(
    $projectId: ID!
    $productId: ID!
    $product: InputProduct!
    $categoryId: ID!
  ) {
    editProduct(
      projectId: $projectId
      productId: $productId
      product: $product
      categoryId: $categoryId
    ) {
      id
      name
      brand
      categoriesV2 {
        id
        category
      }
      properties {
        id
        name
        value
      }
      images {
        src
      }
      description
      defaultPrice
      isCustomSKU
      productCode
      productSKUs {
        id
        price
        productCode
        productType {
          id
          value
          key {
            id
            key
          }
        }
        isFree
        deleted
        selected
        reserved
        inventory
        image {
          src
        }
      }
    }
  }
`

export const REMOVE_LINE_NOTIFICATION = gql`
  mutation($projectId: ID!, $permissionId: ID!) {
    removeLineNotification(projectId: $projectId, permissionId: $permissionId) {
      isEnableNotification
    }
  }
`

export const GENERATE_NOTIFICATION_KEY = gql`
  mutation($projectId: ID!, $userId: ID!) {
    generateOTP(projectId: $projectId, userId: $userId) {
      OTP
      projectId
      userId
    }
  }
`

export const DELETE_PRODUCT = gql`
  mutation($projectId: ID!, $id: ID!) {
    deleteProduct(projectId: $projectId, id: $id) {
      id
      name
      brand
      categoriesV2 {
        id
        category
      }
      properties {
        name
        value
      }
      images {
        src
      }
      description
      defaultPrice
      isCustomSKU
      productCode
      productSKUs {
        id
        price
        productCode
        productType {
          value
          key {
            key
          }
        }
        deleted
        selected
        image {
          src
        }
      }
    }
  }
`

export const NEW_CART = gql`
  mutation($projectId: ID!, $customerId: ID!, $items: [ItemInput]!) {
    newCart(projectId: $projectId, customerId: $customerId, items: $items) {
      items {
        productId
        productSKUId
        amount
        isFree
      }
    }
  }
`

export const NEW_ORDER = gql`
  mutation(
    $projectId: ID!
    $customerId: ID!
    $shippingMethod: String!
    $orderProducts: [OrderProductInput]!
  ) {
    newOrder(
      projectId: $projectId
      customerId: $customerId
      shippingMethod: $shippingMethod
      orderProducts: $orderProducts
    ) {
      orderNumber
    }
  }
`

export const UPDATE_FAQ = gql`
  mutation($projectId: ID!, $faq: [FaqInput]!) {
    updateFAQ(projectId: $projectId, faq: $faq) {
      name
      questions
      response {
        type
        value
      }
    }
  }
`

export const TRAIN_FAQ = gql`
  mutation($projectId: ID!) {
    createTrainJob(projectId: $projectId) {
      id
      status
      timestamp
    }
  }
`

export const UPDATE_PAYMENT = gql`
  mutation($projectId: ID!, $payment: InputPayment!) {
    updatePayment(projectId: $projectId, payment: $payment) {
      bankAccounts {
        bankName
        accountName
        accountNo
        branch
      }
      promptPay {
        accountName
        accountNo
      }
    }
  }
`

export const UPDATE_SHOP = gql`
  mutation($projectId: ID!, $detail: InputShopDetail!) {
    updateShopDetail(projectId: $projectId, detail: $detail) {
      image
      general {
        name
        address {
          address_1
          address_2
          district
          subDistrict
          province
          postcode
          branch
        }
        phoneNumber
      }
      socialMedia {
        facebook
        instagram
        twitter
        website
      }
    }
  }
`

export const UPDATE_VAT = gql`
  mutation($projectId: ID!, $vat: InputVat!) {
    updateVat(projectId: $projectId, vat: $vat) {
      vatOptions
      vatPercentage
      vatId
      isShowTaxInfo
    }
  }
`

export const UPDATE_SHIPPING_METHOD = gql`
  mutation($projectId: ID!, $shipping: [InputShippingMethod]!) {
    updateDefaultShippingMethod(projectId: $projectId, shipping: $shipping) {
      method
      calculateType
      pricePerUnit
      minimumPrice
      maximumPrice
      fixedPrice
      minDuration
      maxDuration
      description
    }
  }
`

export const UPDATE_GREETINGS_MESSAGE = gql`
  mutation($projectId: ID!, $messages: [InputGreetingMessage]!) {
    updateGreetingMessage(projectId: $projectId, messages: $messages) {
      type
      value
    }
  }
`

export const UPDATE_RESPONSE_MESSAGE = gql`
  mutation($projectId: ID!, $responseMessage: [ResponseMessageInput]!) {
    updateResponseMessage(
      projectId: $projectId
      responseMessage: $responseMessage
    ) {
      name
    }
  }
`

export const CONNECT_TO_FACEBOOK_PAGE = gql`
  mutation($projectId: ID!, $pageDetail: PageDetailInput!) {
    connectFacebookPage(projectId: $projectId, pageDetail: $pageDetail)
  }
`

export const DISCONNECT_TO_FACEBOOK_PAGE = gql`
  mutation($projectId: ID!) {
    disconnectFacebookPage(projectId: $projectId)
  }
`

export const IMPORT_PRODUCT = gql`
  mutation($projectId: ID!, $productList: [InputProduct]!) {
    importProduct(projectId: $projectId, productList: $productList) {
      id
      name
      brand
      categories {
        id
        category
      }
      categoriesV2 {
        id
        category
      }
      properties {
        id
        name
        value
      }
      images {
        src
      }
      description
      defaultPrice
      isCustomSKU
      productCode
      productSKUs {
        id
        price
        productCode
        productType {
          id
          value
          key {
            id
            key
          }
        }
        deleted
        selected
        reserved
        inventory
        image {
          src
        }
      }
    }
  }
`

export const UPDATE_INVENTORY = gql`
  mutation($projectId: ID!, $inventories: [InputInventory]!) {
    updateInventory(projectId: $projectId, inventories: $inventories) {
      productSKUId
      amount
    }
  }
`

export const ADD_SHIPPING_PROMOTION = gql`
  mutation(
    $projectId: ID!
    $shippingPromotion: ShippingPromotionInput!
    $productRelated: [ProductRelatedInput]
  ) {
    addShippingPromotion(
      projectId: $projectId
      shippingPromotion: $shippingPromotion
      productRelated: $productRelated
    ) {
      id
      name
      description
      isActive
      groupType
      discountType
      amount
      shippingMethod
      productSKUs {
        id
        product {
          name
        }
        productCode
        price
        image {
          src
        }
        selected
        deleted
        productType {
          id
          value
          key {
            id
            key
          }
        }
        createdAt
        updatedAt
      }
    }
  }
`

export const UPDATE_SHIPPING_PROMOTION = gql`
  mutation(
    $projectId: ID!
    $shippingPromotion: ShippingPromotionInput!
    $productRelated: [ProductRelatedInput]
  ) {
    updateShippingPromotion(
      projectId: $projectId
      shippingPromotion: $shippingPromotion
      productRelated: $productRelated
    ) {
      id
      name
      description
      isActive
      groupType
      discountType
      amount
      shippingMethod
      productSKUs {
        id
        product {
          name
        }
        productCode
        price
        image {
          src
        }
        selected
        deleted
        productType {
          id
          value
          key {
            id
            key
          }
        }
        createdAt
        updatedAt
      }
    }
  }
`

export const REMOVE_SHIPPING_PROMOTION = gql`
  mutation($projectId: ID!, $shippingPromotionId: ID!) {
    removeShippingPromotion(
      projectId: $projectId
      shippingPromotionId: $shippingPromotionId
    )
  }
`

export const ADD_PRODUCT_PROMOTION = gql`
  mutation(
    $projectId: ID!
    $productPromotion: ProductPromotionInput!
    $productRelated: [ProductRelatedInput]
  ) {
    addProductPromotion(
      projectId: $projectId
      productPromotion: $productPromotion
      productRelated: $productRelated
    ) {
      id
      name
      description
      isActive
      type
      promotionDetails {
        by
        rule
        type
        amount
        price
        buyCondition
        getValue
        productId
        skuId
      }
      productSKUs {
        id
        product {
          name
        }
        productCode
        price
        image {
          src
        }
        selected
        deleted
        productType {
          id
          value
          key {
            id
            key
          }
        }
        createdAt
        updatedAt
      }
    }
  }
`

export const UPDATE_PRODUCT_PROMOTION = gql`
  mutation(
    $projectId: ID!
    $productPromotion: ProductPromotionInput!
    $productRelated: [ProductRelatedInput]
  ) {
    updateProductPromotion(
      projectId: $projectId
      productPromotion: $productPromotion
      productRelated: $productRelated
    ) {
      id
      name
      description
      isActive
      type
      promotionDetails {
        by
        rule
        type
        amount
        price
        buyCondition
        getValue
        productId
        skuId
      }
      productSKUs {
        id
        product {
          name
        }
        productCode
        price
        image {
          src
        }
        selected
        deleted
        productType {
          id
          value
          key {
            id
            key
          }
        }
        createdAt
        updatedAt
      }
    }
  }
`

export const REMOVE_PRODUCT_PROMOTION = gql`
  mutation($projectId: ID!, $productPromotionId: ID!) {
    removeProductPromotion(
      projectId: $projectId
      productPromotionId: $productPromotionId
    )
  }
`

export const REMOVE_SHIPPING_RULE = gql`
  mutation($projectId: ID!, $shippingMethodId: ID!) {
    removeShippingMethod(
      projectId: $projectId
      shippingMethodId: $shippingMethodId
    )
  }
`

export const ADD_SHIPPING_RULE = gql`
  mutation(
    $projectId: ID!
    $productSKUIds: [ID]!
    $shippingDetail: InputShipping
  ) {
    addProductShippingMethod(
      projectId: $projectId
      productSKUIds: $productSKUIds
      shippingDetail: $shippingDetail
    ) {
      id
      method
      calculateType
      pricePerUnit
      minimumPrice
      fixedPrice
      minDuration
      maxDuration
      description
      productSKUs {
        id
        productCode
        price
        image {
          src
        }
        selected
        deleted
        productType {
          id
          value
          key {
            id
            key
          }
        }
        createdAt
        updatedAt
      }
    }
  }
`

export const UPDATE_SHIPPING_RULE = gql`
  mutation(
    $projectId: ID!
    $productSKUIds: [ID]!
    $shippingDetail: InputShipping
  ) {
    updateShippingMethod(
      projectId: $projectId
      productSKUIds: $productSKUIds
      shippingDetail: $shippingDetail
    ) {
      id
      method
      calculateType
      pricePerUnit
      minimumPrice
      fixedPrice
      minDuration
      maxDuration
      description
      productSKUs {
        id
        productCode
        price
        image {
          src
        }
        selected
        deleted
        productType {
          id
          value
          key {
            id
            key
          }
        }
        createdAt
        updatedAt
      }
    }
  }
`

export const UPDATE_BOT_TIMER = gql`
  mutation($projectId: ID!, $botTimer: BotTimerInput!) {
    updateBotTimer(projectId: $projectId, botTimer: $botTimer) {
      isOpen
      timeToResume
    }
  }
`

export const UPDATE_SEARCH_PRODUCTS_ORDER = gql`
  mutation($projectId: ID!, $searchProductsOrder: String!) {
    updateSearchProductsOrder(
      projectId: $projectId
      searchProductsOrder: $searchProductsOrder
    )
  }
`

export const UPDATE_BOT_GENDER = gql`
  mutation($projectId: ID!, $projectInput: ProjectInput!) {
    updateProject(projectId: $projectId, projectInput: $projectInput) {
      id
      botGender
    }
  }
`

export const UPDATE_VAT_V2 = gql`
  mutation updateVatV2($projectId: ID!, $vatId: ID!, $vat: VatInput) {
    updatedVat: updateVatV2(projectId: $projectId, vatId: $vatId, vat: $vat) {
      id
      projectId
      taxId
      option
      isShowTaxInfo
      rate
      companyName
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/mutation.js